import React, { useEffect, useState } from "react";
import Savepropertypopup from "../savepropertypopup/savepropertypopup";
import PropertyShowcaseCard from "../common/PropertyShowcaseCard/PropertyShowcaseCard";
import PropertyWorthCard from "../common/PropertyWorthCard/PropertyWorthCard";
import PropertySoldCard from "../common/PropertySoldCard/PropertySoldCard";
import Loder from "../common/Loder";
import Layout1 from "../../Layouts/Layout1";
import { toast } from "react-toastify";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import axiosInstance from "../../apiInstances/axiosInstance";
import { useNavigate, useSearchParams } from "react-router-dom";
import heart from "../../assets/heart_icon.png";
import agency4 from "../../assets/agency-4.png";
import agent2 from "../../assets/agent-2.png";
import NewHomesFilter from "./NewHomesFilter";
import VerticalAds from "../Adds/VerticalAds";
import { usePropertyData } from "../../context/PropertyDataContext";
import { AuthModal } from "../../models/AuthModal";
import FilterNavTab from "../common/FilterNavTab/FilterNavTab";
import { PropertyCardSkeletonList } from "../Skeleton/PropertyCardSkeleton";
import { PropertyCardList } from "../common/PropertyCard/PropertyCard";
import LayoutContainer from "../../Layouts/LayoutContainer";

const NewHomes = () => {
  const onClose = () => setSavepropertypopup(false);
  const navigate = useNavigate();
  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [savepropertypopup, setSavepropertypopup] = useState(false);
  const [Searchindata, setSearchindata] = useState([]);
  const [homePropertyData, setHomePropertyData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isAuthanticate = localStorage.getItem("Token");
  const TabData = ["New Apartments", "House & Land"];
  const Filterable = ["New Apartments", "House & Land"];
  const [isActiveTab, setIsActiveTab] = useState(TabData[0]);
  const { getCachedData, cachePropertyData } = usePropertyData();
  const [Filter, setFilter] = useState({
    search: "",
    category: "",
    status: "new",
    property_type: "Apartment",
    agent: "",
    sort_by: "",
    serachbyaddress: "",
  });

  const allpropertyid =
    homePropertyData?.length > 0 &&
    homePropertyData?.map((data) => {
      if (data?._id) {
        return data?.id;
      }
      return data?.id;
    });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  let [data] = useSearchParams();
  const encryptedData = data.get("encryptedData");
  //console.log("🚀 ~ BuyProperty ~ encryptedData:-------------", encryptedData)

  const [ads, setAds] = useState([]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(async (pos) => {
      const { longitude, latitude } = pos.coords;
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
      axiosInstance(url)
        .then((data) => {
          const state = data.data.address.state.split(" ")[0];
          getAdsList(state);
        })
        .catch((err) => console.log("err", err));
    });
  }, []);

  const getAdsList = (state) => {
    axiosInstance
      .get(`/advertise/ads/list?address=${state}`)
      .then((res) => {
        const result = res.data.data;
        setAds(result);
      })
      .catch((error) => console.log("err --->", error));
  };

  useEffect(() => {
    GetSavedProperty("");
    if (encryptedData) {
      search();
    } else {
      // GetAllListingData(Filter);
    }
  }, [encryptedData]);

  const GetAllListingData = async (Filter) => {
    try {
      const res = await axiosInstance.post("Agency/viewAllProperty", {
        status: Filter?.status,
        property_type: Filter?.property_type,
      });

      if (res?.data?.status) {
        const myData = res?.data?.data;
        const newArray = myData.map((obj, i) => ({
          ...obj,
          id: myData?.[i]?.id,
          frontPageImg: myData?.[i]?.frontPageImg,
          agencyImg: agency4,
          agentImg: agent2,
          lead_agent: myData?.[i]?.lead_agent,
          price: myData?.[i]?.price,
          price_display_checked: myData?.[i]?.price_display_checked,
          price_display: myData?.[i]?.price_display,
          street_address_number: myData?.[i]?.street_address_number,
          street_address_name: myData?.[i]?.street_address_name,
          favorite: false,
          bedroomCount: myData[i]?.Bedrooms,
          showerCount: myData[i]?.Bathrooms,
          carCount: myData[i]?.carport_spaces,
          squareCount: "6,580 m2",
          apartmentCount: "",
          acreageCount: myData[i]?.property_type,
        }));
        let newResponse = newArray.map((x) => ({
          ...x,
          favorite: localStorage.getItem("Saved")?.split(",").includes(x.id),
        }));
        return newResponse;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const search = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const res = await axiosInstance.post("/searchProperty", { userId: userData?.id, encryptedData });
      if (res?.data?.status) {
        const mydata = res?.data?.data;
        const newArray = mydata.map((obj, i) => ({
          ...obj,
          id: mydata?.[i]?.id,
          frontPageImg: mydata?.[i]?.frontPageImg,
          agencyImg: agency4,
          agentImg: agent2,
          lead_agent: mydata?.[i]?.lead_agent,
          price: mydata?.[i]?.price,
          street_address_number: mydata?.[i]?.street_address_number,
          street_address_name: mydata?.[i]?.street_address_name,
          favorite: false,
          bedroomCount: mydata[i]?.Bedrooms,
          showerCount: mydata[i]?.Bathrooms,
          carCount: mydata[i]?.carport_spaces,
          squareCount: "6,580 m2",
          apartmentCount: "",
          acreageCount: mydata[i]?.property_type,
          // saleDate: `Sold on ${i + 10} Oct 2022`,
        }));
        let newResponse = newArray.map((x) => ({
          ...x,
          favorite: localStorage.getItem("Saved")?.split(",").includes(x.id),
        }));
        return newResponse;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const GetSavedProperty = async (isActive) => {
    await axiosInstanceAuth
      .post(`savedProperty`, {
        status: isActive,
      })
      .then((res) => {
        const mydata = res?.data?.data;

        if (res?.data?.status) {
          localStorage.setItem(
            "Saved",
            mydata.map((obj, i) => `${mydata?.[i]?._id}`),
          );
        } else {
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const customsort = (value) => {
    if (value === "DE") {
      const nextinspection = Searchindata.filter(
        (data) => new Date() < new Date(data.inpection_time),
      );
      if (nextinspection != "") {
        setHomePropertyData(nextinspection);
      } else {
        alert("inpection is blank");
      }
    } else {
      value === "priceDescending" || value === "priceAsending"
        ? value === "priceDescending"
          ? setHomePropertyData((prevData) =>
            [...prevData].sort((a, b) => b.price - a.price),
          )
          : setHomePropertyData((prevData) =>
            [...prevData].sort((a, b) => a.price - b.price),
          )
        : value === "dateDescending"
          ? setHomePropertyData((prevData) =>
            [...prevData].sort(
              (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
            ),
          )
          : setHomePropertyData((prevData) =>
            [...prevData].sort(
              (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt),
            ),
          );
    }
  };

  useEffect(() => {
    customsort(Filter?.sort_by);
  }, [Filter?.sort_by]);

  const activeTab = (tab) => {
    setIsActiveTab(tab);
    const newFilter = {
      ...Filter,
      property_type: tab === "House & Land" ? "House&Land" : "Apartment",
    };
    setFilter(newFilter);
  };

  useEffect(() => {
    const fetchData = async () => {
      const cacheKey = isActiveTab;
      const cachedData = getCachedData(cacheKey);
      if (cachedData) {
        setHomePropertyData(cachedData);
        setSearchindata(cachedData); // Also set search data
        return;
      }
      setIsLoading(true);
      try {
        let result;
        if (encryptedData) {
          result = await search();
        } else {
          result = await GetAllListingData(Filter);
        }
        setHomePropertyData(result);
        setSearchindata(result);
        cachePropertyData(cacheKey, result);
      } catch (error) {
        console.error("Error:", error);
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [encryptedData, Filter.status, isActiveTab]);


  const ActiveTab =
    "bg-blue-50 border-b-blue-600 rounded-t-lg text-black font-semibold text-[#404040]";

  const NormalTab =
    "w-full grid place-items-center place-content-center text-[#737373] font-medium text-xs md:text-sm border border-b-2 border-transparent hover:border-b-blue-600 py-4 px-5 md:px-10 ease-in-out duration-700 cursor-pointer ";

  return (
    <>
      <FilterNavTab currentTab={isActiveTab} dataCount={homePropertyData?.length} isNewHomes={true} />
      <LayoutContainer>
        <div className="container mx-auto w-full flex justify-start items-start border border-b-1  border-transparent border-b-[#E5E5E5]">
          {TabData?.length > 0 &&
            TabData?.map((d, index) => (
              <div
                key={index}
                className={`${NormalTab} ${isActiveTab === d ? ActiveTab : ""}`}
                onClick={(e) => {
                  activeTab(d);
                }}
              >
                {d}
              </div>
            ))}
        </div>
      </LayoutContainer>
      <Layout1>
        <LayoutContainer>
          <div className="w-full flex flex-col lg:flex-row items-start gap-8">
            <div className="flex flex-col gap-6 w-full flex-1 min-w-0 lg:max-w-[910px] my-10 lg:my-16">
              {isLoading ? (
                <PropertyCardSkeletonList count={5} />
              ) : (
                <>
                  <PropertyCardList
                    PropertyData={homePropertyData}
                    setPropertyData={setHomePropertyData}
                    style="mb-5"
                    adsList={ads?.betweenAds}
                  />
                </>
              )}
            </div>
            <div className="hidden sticky top-6 lg:block shrink-0 lg:w-[265px] xl:w-[300px] 2xl:w-[360px] my-10 lg:my-16">
              <div className="w-full ">
                {/* <PropertyShowcaseCard PropertyData={homePropertyData} /> */}
                {/* <PropertyWorthCard style="my-10" /> */}
                {ads?.verticalAds &&
                  ads?.verticalAds.length > 0 &&
                  ads?.verticalAds?.map((items, index) => {
                    return (
                      <VerticalAds style="my-10" adsList={items} key={index} />
                    );
                  })}
              </div>
            </div>
          </div>
          {
            savepropertypopup ? (
              <Savepropertypopup allpropertyid={allpropertyid} onClose={onClose} />
            ) : null
          }

          {
            AuthPopUp ? (
              <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
            ) : null
          }
        </LayoutContainer >
      </Layout1>
    </>
  );
};

export default NewHomes;
